function roundAndFormat(num: number, step = 0.05, decimals = 2) {
  const rounded = Math.round(num / step) * step;
  return Number(rounded.toFixed(decimals));
}

export const calculateUnits = (
  dosage: number,
  strength: number,
  reference: number
) => {
  const rawUnit = (dosage / (strength / reference)) * 100;

  return roundAndFormat(rawUnit);
};
